module.exports = {
      id: "gallery-scope-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#gallery-scope",
      toString: function () {
        return this.url;
      }
    }